var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('candle-pair'),_c('transition',{attrs:{"name":"pentagon-page","mode":"out-in"},on:{"after-leave":_vm.onPageLeft}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }